/* eslint-disable */

import MoveElements from '../util/moveElements.js';

export default {
  init() {
		// let moveTopCTA = new MoveElements({
		//   element: document.querySelector('a[href="#pourquoi"]'),
		// 	breakpoint: "767px",
		//   mobile: {
		// 		append: 'after',
		// 		element: document.querySelector('.block--4 .right')
		//   },
		//   desktop: {
		// 		append: 'after',
		// 		element: document.querySelector('.block--4 .left')
		//   }
		// });
    // let moveBottomCTA = new MoveElements({
		//   element: document.querySelector('.block--bg-primary.block--2 .block-link__list'),
		// 	breakpoint: "767px",
		//   mobile: {
		// 		append: 'after',
		// 		element: document.querySelector('.block--bg-primary.block--2 .right')
		//   },
		//   desktop: {
		// 		append: 'after',
		// 		element: document.querySelector('.block--bg-primary.block--2 .left')
		//   }
		// });
    //clients/references slider
    var clients_list = $('#nos-clients .js-reference-list');
    if(clients_list.length) {
      setTimeout(function(){

        clients_list.slick({
          slidesToShow: 2,
          slidesperRow: 2,
          rows: 2,
          slidesToScroll: 1,
          initialSlide: 1,
          // asNavFor: 'nos-clients .js-reference-avis',
          arrows: true,
          // centerMode: true,
          // centerPadding: '6.875%',
          // centerPadding: '0%',
          focusOnSelect: true,
          mobileFirst: true,
          responsive: [
            {
              breakpoint: 767,
              settings: {
                // centerMode: false,
                // centerPadding: '0%',
                rows: 1,
                slidesToShow: 5,
                slidesToScroll: 1,
                arrows: false
              }
            },
            {
              breakpoint: 1023,
              settings: {
                // centerMode: false,
                // centerPadding: '0%',
                rows: 1,
                slidesToShow: 5,
                slidesToScroll: 1,
                arrows: true
              }
            },
            // {
              //   breakpoint: 1024,
              //   settings: {
                //     slidesToShow: 3,
                //     slidesToScroll: 1,
                //     centerPadding: '8.28125%',
                //     arrows: false
                //   }
                // }
              ]
            });
        }, 1500);
          // .on('beforeChange', function(event, slick, currentSlide, nextSlide){
            // });

    }
	},
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
}



// WEBPACK FOOTER //
// ./scripts/routes/quiSommesNous.js